module.exports = __webpack_public_path__ + "img/1440.c3ae7a11.jpg";